import localforage from 'localforage'
// src is a alias. see client/build/webpack.base.conf.js
import { userTokenStorageKey } from 'src/config'
import { isEmpty } from 'lodash'
import * as TYPES from './mutations-types'
import * as services from '../services'
import UTILITY from '../../../utils/common.js'

export const attemptLogin = ({ dispatch }, payload) =>
  services.postLogin(payload).then((response) => {
    UTILITY.setItemLocalStorage('emailRem-token',response.token)
    let token = localStorage.getItem('emailRem-token');
    if(token) {
      dispatch('setToken', token)  
      dispatch('updateBaseUrl', 4)
    }
    dispatch('setUser', response.user)
    UTILITY.setItemLocalStorage('emailRem-token', response.token)
    if(response.user && !response.user.firstTime && response.user.lastPasswordChangedTime < response.user.passwordExpiryTime ){
      UTILITY.setItemLocalStorage('user', JSON.stringify(response.user))
    };
    return response;
  })
  export const attemptLoginViaO365 = ({ dispatch }, payload) =>
    services.getUserForO365Login(payload).then((response) => {
      if (response && response.token) {
        UTILITY.setItemLocalStorage('emailRem-token', response.token)
        let token = localStorage.getItem('emailRem-token');
        if (token) {
          dispatch('setToken', token);
          dispatch('updateBaseUrl', 2);
        }
        dispatch('setUser', response);
        UTILITY.setItemLocalStorage('user', JSON.stringify(response))
        return response;
      }
  })

    export const attemptLoginViaAD = ({ dispatch }, payload) =>
    services.getUserForAD(payload)
    .then((response) => {
      
      if (response && response.token) {
        localStorage.setItem('emailRem-token', response.token);
        let token = localStorage.getItem('emailRem-token');
        if (token) {
          dispatch('setToken', token);
          dispatch('updateBaseUrl', 4);
        }
        dispatch('setUser', response);
        localStorage.setItem('user', JSON.stringify(response));
        return response;
      }
    })    

export const attemptLoginViaGoogle = ({ dispatch }, payload) =>
    services.getUserForGoogleLogin(payload)
    .then((response) => {
      if (response && response.token){
        UTILITY.setItemLocalStorage('emailRem-token', response.token)
        let token = localStorage.getItem('emailRem-token');
        if(token) {
          dispatch('setToken', token)  
          dispatch('updateBaseUrl', 1)
        }
        dispatch('setUser', response)
        UTILITY.setItemLocalStorage('user', JSON.stringify(response))
        return response;
      }

    }).catch((e)=>{
      // pass
    })

export const attemptLoginViaOutlook = ({ dispatch }, payload) =>
    services.getUserForOutlookLogin(payload)
    .then((response) => {
      if (response && response.token) {
        UTILITY.setItemLocalStorage('emailRem-token', response.token)
        let token = localStorage.getItem('emailRem-token');
        if(token) {
          dispatch('setToken', token)
          dispatch('updateBaseUrl', 3)
        }
        dispatch('setUser', response)
        UTILITY.setItemLocalStorage('user', JSON.stringify(response))
      }
      return response;
    })

export const attemptRegister = ({ dispatch }, payload) =>
    services.postRegister(payload)
    .then( (response) => {
      return response // keep promise chain
    })

  export const attemptVerification = ({ dispatch }, payload) =>
    services.postVerification(payload).then((response) => {
      dispatch('setToken', null)
      dispatch('setToken', response)
      dispatch('setUser', response.user)
      UTILITY.setItemLocalStorage('user', JSON.stringify(response.user))
      return response // keep promise chain
    }).catch((e)=>{
      // pass
    })

export const attemptLoginVerification = ({ dispatch }, payload) =>
    services.attemptLoginVerification(payload)
        .then((response) => {
            dispatch('setToken', null)
            dispatch('setToken', response.token)
            dispatch('setUser', response.user)
            UTILITY.setItemLocalStorage('user', JSON.stringify(response.user))
            if (response && response.login){
            if (response.user.displaymode){
              if (response.user.displaymode == 1 ){
                $('body').addClass('dark_mode');
              }
            }
          }
            return response // keep promise chain
        }).catch((e)=>{
          // pass
        })


export const attempt2FASkipVerification = ({ dispatch }, payload) =>
    services.attempt2FASkipVerification(payload)
        .then((response) => {
            dispatch('setToken', null)
            dispatch('setToken', response.token)
            dispatch('setUser', response.user)
            UTILITY.setItemLocalStorage('user', JSON.stringify(response.user))
            if (response && response.login){
            if (response.user.displaymode){
              if (response.user.displaymode == 1 ){
                $('body').addClass('dark_mode');
              }
            }
          }
            return response // keep promise chain
        }).catch((e)=>{
          // pass
        })

export const logout = ({ dispatch }) => {
  
  // services.revokeToken()
  localStorage.clear();
  // call actions
  return Promise.all([
    dispatch('setToken', null),
    dispatch('updateBaseUrl', null),
    dispatch('setUser', {})
  ]).catch((e)=>{
    // pass
  })
}

export const setUser = ({ commit }, user) => {
  // Commit the mutations
  commit(TYPES.SET_USER, user)

  Promise.resolve(user) // keep promise chain
}

export const setToken = ({ commit }, payload) => {

  // prevent if payload is a object
  const token = (isEmpty(payload)) ? null : payload.token || payload

  // Commit the mutations
  commit(TYPES.SET_TOKEN, token)

  return Promise.resolve(token) // keep promise chain
}

export const updateBaseUrl = ({ commit }, payload) => {

  // prevent if payload is a object
  const token = (isEmpty(payload)) ? null : payload.token || payload

  // Commit the mutations
  commit(TYPES.SET_BASE_URL, token)

  return Promise.resolve(token) // keep promise chain
}

export const checkUserToken = ({ dispatch, state }) => {

  // If the token exists then all validation has already been done
  if (!isEmpty(state.token)) {
    return Promise.resolve(state.token)
  }

  /**
   * Token does not exist yet
   * - Recover it from localstorage
   * - Recover also the user, validating the token also
   */ 
   var token = localStorage.getItem('login');
   if(token){
    return Promise.resolve(state.token)
   }else{
    return Promise.reject('NO_TOKEN');
   }
   
   // return false;
   // if(localstorage.getItem('login'),)
  // return localforage.getItem(userTokenStorageKey)
    // .then((token) => {
      // if (isEmpty(token)) {
        // Token is not saved in localstorage
        // return Promise.reject('NO_TOKEN') // Reject promise
      // }
      // Put the token in the vuex store
      // return dispatch('setToken', token) // keep promise chain
    // })
    // With the token in hand, retrieves the user's data, validating the token
    // .then(() => dispatch('loeadUser'))
}

/**
 * Retrieves updated user information
 * If something goes wrong, the user's token is probably invalid
 */
export const loadUser = ({ dispatch }) => services.loadUserData()
  // store user's data
  .then(user => dispatch('setUser', user.data))
  .catch(() => {
    // Process failure, delete the token
    dispatch('setToken', '')
    return Promise.reject('FAIL_IN_LOAD_USER') // keep promise chain
  })



// WEBPACK FOOTER //
// ./src/app/auth/vuex/actions.js